import React from 'react'
import { useStyles } from './header.styles'
import { useMediaQueryContext } from 'app/shared/components/mediaqueryprovider'
import { NavigationBar } from './navigation'
import DefaultLogo from 'app/resources/media/logo.jpg'
import { useHistory } from 'react-router-dom'
import HeaderInfo from './header-info/header-info'
import { useThemeContext } from 'app/shared/state/theme-context'
import CompaniesSelect from './companies-select/companies-select'

const Header = () => {
  const classes = useStyles()
  const { theme } = useThemeContext()
  const { mobileView } = useMediaQueryContext()

  const { push } = useHistory()

  const logoClick = () => {
    push('/')
  }

  if (mobileView) {
    return (
      <div className={classes.root}>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={theme?.logo || DefaultLogo} alt="Logo" onClick={logoClick} />
        </div>
        <div className={classes.navigation} style={{ backgroundColor: theme?.backgroundColor || 'inherit' }}>
          <div className={classes.info}>
            <CompaniesSelect />
            <HeaderInfo />
          </div>
          <div className={classes.navigationBar}>
            <NavigationBar />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        <img className={classes.logo} src={theme?.logo || DefaultLogo} alt="Logo" onClick={logoClick} />
      </div>
      <div className={classes.navigation} style={{ backgroundColor: theme?.backgroundColor || 'inherit' }}>
        <div className={classes.navigationInfo}>
          <div className={classes.info}>
            <div className={classes.branding}>
              <img src="/axs_logo_payoff.png" height="45" alt="Logo payoff" />
            </div>
            <CompaniesSelect />
            <HeaderInfo />
          </div>
          <div className={classes.navigationBar}>
            <NavigationBar />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
